export class DumpMethodFilterProvider {
    filter(url) {
        let reg = new RegExp(".*\/dump.*", "i")

        return reg.test(url);
    }
}


// WEBPACK FOOTER //
// ./src/services/resources/filterProvider/DumpMethodFilterProvider.js